import { track } from '../analytics/seshat/index';
import bootstrapper from '../bootstrapper';
import {
  displayFlashErrorMessage,
  removeFlashErrorMessage,
  handleScroll,
  hideFloatingErrorMessage,
  showFloatingErrorMessage,
  transactionUUID,
  installmentsNumber,
  disableItems,
  addPaymentHelp,
} from './checkoutHelpers';
import { clientSideFailedPaymentPayload, createFailedPayment } from './createFailedPayment';
import sendTrackpointEvent from '../trackpoint/sendEvent';
import PaymentSubmission from './paymentSubmission';

let stripeElements;
let stripe;
let paymentIntentInfo;

const requestUrl = () => {
  const paymentForm = document.getElementById('payment-form');
  const serverUrl = paymentForm.action;

  return serverUrl;
};

const updateChargeAmount = async (paymentMethod, paymentInstallmentId, paymentId) => {
  const paymentSubmission = new PaymentSubmission(
    paymentMethod,
    paymentInstallmentId,
    paymentId,
  );
  paymentSubmission.reload();
};

const couponCode = () => {
  const couponField = document.querySelector('#shop_payment_installment_coupon');
  const coupon = couponField?.value;

  return coupon;
};

const enablePaymentMethodSwitch = async (res) => {
  // Use querySelectorAll to get all elements whose IDs start with 'switch-to-bank-debit'
  const paymentMethodSwitches = document.querySelectorAll('[id^="switch-to-bank-debit"]');

  paymentMethodSwitches.forEach((paymentMethodSwitch) => {
    paymentMethodSwitch.value = res.available_alternative_payment_method;

    if (!paymentMethodSwitch.classList.contains('d-none')) {
      return;
    }

    paymentMethodSwitch.classList.remove('d-none');

    // Add event listeners to each switch
    paymentMethodSwitch.addEventListener('click', () => {
      track({
        eventName: 'click_payment_method_switch',
        options: {
          order_id: res.order_id,
          payment_installment_id: res.payment_installment_id,
          payment_id: res.payment_id,
        },
      });
    });

    paymentMethodSwitch.addEventListener('click', (e) => {
      hideFloatingErrorMessage();
      window.removeEventListener('scroll', handleScroll);
      removeFlashErrorMessage();
      updateChargeAmount(
        e.target.value,
        paymentIntentInfo.payment_installment_id,
        paymentIntentInfo.payment_id,
      );
    },

    );
  });

  document.cookie = 'payment_method_switch_displayed=true; path=/';
  track({
    eventName: 'show_payment_method_switch',
    options: {
      order_id: res.order_id,
      payment_installment_id: res.payment_installment_id,
      payment_id: res.payment_id,
    },
  });
};

const addEventListenerToPaymentHelp = (paymentHelp, res) => {
  paymentHelp.addEventListener('click', () => {
    const modalContainer = document.getElementById('payment-support-modal-container');
    modalContainer.classList.remove('d-none');
    track({
      eventName: 'click_payment_help_button',
      options: {
        order_id: res.order_id,
        payment_installment_id: res.payment_installment_id,
        payment_id: res.payment_id,
      },
    });
  });
  paymentHelp.classList.remove('d-none');
};


const enablePaymentHelp = (res) => {
  const fixedPaymentHelp = document.getElementById('payment-help-fixed');
  addEventListenerToPaymentHelp(fixedPaymentHelp, res);

  if (res.selected_payment_method === 'sepa_debit' || res.available_alternative_payment_method === 'sepa_debit') {
    const floatingPaymentHelp = document.getElementById('payment-help-floating');
    addEventListenerToPaymentHelp(floatingPaymentHelp, res);
  }
};

const createFailedPaymentWithError = async (error) => {
  const body = clientSideFailedPaymentPayload('stripe_intent', error, null, installmentsNumber());
  await createFailedPayment(body).then(res => res.json())
    .then((res) => {
      displayFlashErrorMessage(res.error_message);
      if (res.selected_payment_method === 'sepa_debit') {
        showFloatingErrorMessage();
        // Add scroll listener
        window.addEventListener('scroll', handleScroll);
        // Initial check
        handleScroll();
      }
      if (res.allow_payment_method_switch === true) {
        enablePaymentMethodSwitch(res);
      }

      if (res.allow_payment_help === true) {
        addPaymentHelp(res);
        enablePaymentHelp(res);
      }

      if (res.allow_payment_method_switch === true && res.allow_payment_help === true) {
        const spanTexts = document.querySelectorAll('[id^="or-text"]');
        spanTexts.forEach((spanText) => {
          spanText.classList.remove('d-none');
        });
      }
    });
};

const payloadKey = () => (requestUrl().includes('enrollments') ? 'shop_payment_installment' : 'shop_payment');

const createPaymentIntentPayload = () => {
  const payload = {
    coupon: couponCode(),
    [payloadKey()]: {
      number_of_installments: installmentsNumber(),
      transaction_uuid: transactionUUID(),
    },
  };

  return payload;
};

const buildRequestOptions = (body, method) => {
  const CSRFToken = document.querySelector("[name='csrf-token']")?.content;
  const options = {
    method,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json; charset=UTF-8',
      'X-CSRF-Token': CSRFToken,
    },
    ...body && { body: JSON.stringify(body) }, // Merge body only if it's not null
  };
  return options;
};

const getPaymentUrl = (paymentData) => {
  const serverUrl = `${window.location.origin}/${bootstrapper.locale}/payment_installments/${paymentData.paymentInstallmentId}/payments/${paymentData.paymentId}`;
  return serverUrl;
};

const createPaymentIntent = async () => {
  const url = requestUrl();
  const body = createPaymentIntentPayload();
  const options = buildRequestOptions(body, 'POST');

  return fetch(url, options);
};

const processedResponse = async () => {
  const response = await createPaymentIntent();
  const responseData = await response.json();

  if (response.ok) return responseData;

  throw new Error(responseData.error);
};

export const handleStripeElementChangeEvent = (event) => {
  const formEvent = new CustomEvent(
    'payment_form_change',
    { detail: { disable_payment: event.value.type === 'us_bank_account' && !event.complete } },
  );
  document.getElementById('payment-form').dispatchEvent(formEvent);

  if (event.value.type === 'us_bank_account') {
    let eventName;

    if (event.complete) {
      eventName = 'UsBankValidationLinked';
    } else if (event.empty) {
      eventName = 'UsBankMethodSelected';
    } else {
      eventName = 'UsBankMethodFormFilling';
    }

    sendTrackpointEvent({
      ...bootstrapper.stripeDataToLog,
      event: eventName,
      payment_method: event.value.type,
    });
  }
};

export const paymentElementParams = (paymentInfo) => {
  const defaultValues = paymentInfo.guest === false
    ? {
      defaultValues: {
        billingDetails: { ...paymentInfo.billing_details },
      },
    }
    : {};
  const params = {
    paymentMethodOrder: ['alipay', 'us_bank_account', 'card'],
    ...defaultValues,
  };

  return params;
};

const mountStripeElement = (stripePaymentIntentInfo = null) => {
  stripeElements = stripe.elements({ clientSecret: stripePaymentIntentInfo.client_secret });
  const paymentElement = stripeElements.create(
    'payment', paymentElementParams(stripePaymentIntentInfo),
  );
  paymentElement.addEventListener('change', e => handleStripeElementChangeEvent(e));
  paymentElement.mount('#payment-element');
};

const rebuildPaymentElement = async () => {
  const paymentElementForm = document.getElementById('payment-element');
  if (paymentElementForm?.dataset?.remountRequired === 'true') {
    const response = await fetch(getPaymentUrl(paymentElementForm?.dataset), buildRequestOptions(null, 'GET'));
    paymentIntentInfo = await response.json();
    mountStripeElement(paymentIntentInfo);
  }
};

const buildPaymentElement = async () => {
  try {
    paymentIntentInfo = await processedResponse();
    mountStripeElement(paymentIntentInfo);
  } catch (error) {
    displayFlashErrorMessage(error.message);
    // TODO: SELL-1044
    // When an error is generated in the `/enrollments/:enrollment_id/payment_installments`
    disableItems();
  }
};

export const stripeBnplPaymentMethods = () => {
  const methods = ['klarna', 'affirm'];

  return methods;
};

export const payStripeIntent = () => {
  document.querySelector('[data-enrollment-engine--checkout-target="payNowButton"]').classList.add('disabled');

  if (!stripe) { return; } // TODO: to remove this we must refector all the stripe.js file
  stripe.confirmPayment({
    elements: stripeElements,
    confirmParams: {
      return_url: `${window.location.origin}${paymentIntentInfo.success_callback_path}`,
    },
  })
    .then((result) => {
      if (result.error) {
        createFailedPaymentWithError(result.error);
        document.querySelector('[data-enrollment-engine--checkout-target="payNowButton"]').classList.remove('disabled');
      }
    });
};

export const stripeGatewayLoadForm = () => {
  stripe = window.Stripe(
    bootstrapper.stripePublishableKey,
    { locale: bootstrapper.locale },
  );
  return buildPaymentElement();
};

export {
  rebuildPaymentElement,
};
